module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/babel-runtime/core-js/array/from.js
// module id = HvO1
// module chunks = 0